import { RedoOutlined } from '@ant-design/icons';
import {Button, Select, Space, Tooltip} from "antd";
import React from "react";
import {isString} from "lodash";

// todo add tooltips on/off
//  - suite of Bar components, ?maybe a Bar...


export default function Bar({style, children, ...props}){
    return <div style={{margin: 5, padding:5 ,background: '#EEE', borderRadius:5, ...style}} >
        <Space >
            {children}
        </Space>
    </div>
}

export function BarButton({title, placement, style, ...props}) {
    return <Tooltip {...{title, placement}}>
        <Button style={{ borderRadius:5, ...style}}
                size={'small'} {...props}
            type={'primary'}
        />
    </Tooltip>;
}

export function RefreshButton(
    {
        style, primary=false, onRefresh,
        title='refresh', placement,
        ...props
    })
{
    return (
        <Tooltip {...{title, placement}}>
            <Button
                icon={<RedoOutlined />} shape="circle" size="small"
                style={{...{margin: 5}, ...style}}
                onClick={onRefresh}
                type={primary?'primary':'dashed'}
                {...props}
        />
        </Tooltip>
    );
}

export function BarSelect({list = {}, style, ...props}) {
    return <Select size='small' style={{...{margin: 5}, ...style}} {...props}>
        {Object.keys(list).map(key =>
            <Select.Option key={key} value={key}>
                {isString(list[key]) ? list[key] : key}
            </Select.Option>
        )}
    </Select>
}